/**
 * Copyright 2022-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Box, Tabs as TabContainer } from "@nordcloud/gnui";
import { StyledTab } from "~/components/Styled/Tabs";
import { useTabStepNavigation } from "~/hooks";
import { DetailsTab } from "./DetailsTab/DetailsTab";
import { GeneralNotificationsTab } from "./GeneralNotificationsTab/GeneralNotificationsTab";
import { MetadataTab } from "./MetadataTab/MetadataTab";

const TAB_STEP_MAPPING: Record<string, number> = {
  details: 0,
  metadata: 1,
  general_notifications: 2,
};

export function Tabs() {
  const { currentStep, handleTab } = useTabStepNavigation(TAB_STEP_MAPPING);

  return (
    <Box spacing="spacing02" css={{ padding: 0 }}>
      <TabContainer step={currentStep} handleTab={handleTab}>
        <StyledTab heading="Details">
          <DetailsTab />
        </StyledTab>
        <StyledTab heading="Metadata">
          <MetadataTab />
        </StyledTab>
        <StyledTab heading="General Notifications">
          <GeneralNotificationsTab />
        </StyledTab>
      </TabContainer>
    </Box>
  );
}
